<template>
    <div class="contribution-replay-area cb">
        <div class="contribution-replay-btn">
        <span class="btn_not pull-left" v-on:click="changeReplyStatus(true)">
            <i class="fa fa-reply"></i>
            {{ reply_text }}
        </span>
        </div>
        <form-component
            v-if="reply"
            :reply_associated_with="reply_associated_with"
            :reply_info="reply_info"
            :send_text="send_text"
            :cancel_text="cancel_text"
            :id_element="id_element"
            :save_url="reply_url"
            v-on:cancel="changeReplyStatus(false)"
            v-on:saved="saved($event)"
            :terms_text="terms_text"
            :accept_terms_text="accept_terms_text"
        ></form-component>
    </div>
</template>

<script>
    import FormComment from './FormComment.vue';
    export default {
        components: {
            'form-component': FormComment
        },
        props: [
            'reply_text', 'reply_associated_with', 'reply_info', 'send_text', 'cancel_text', 'id_element', 'reply_url',
            'terms_text', 'accept_terms_text'
        ],
        data: function () {
            return {
                reply: false
            }
        },
        methods: {
            changeReplyStatus: function (status) {
                this.reply = status;
            },
            saved: function (comment) {
                this.changeReplyStatus(false);
                this.$emit('saved', comment);
            }
        }
    }
</script>
